<h2 mat-dialog-title>Select Exam</h2>
<div mat-dialog-content>
    <form [formGroup]="dataForm" (ngSubmit)="onSubmit()" class="example-form">
        <mat-form-field appearance="fill" class="example-full-width form-field" style="width: 350px;min-width: auto;">
            <mat-label>Exam</mat-label>
            <input matInput [formControl]="dataForm.get('examControl')" [matAutocomplete]="categoryAuto">
            <mat-autocomplete #categoryAuto="matAutocomplete" [displayWith]="displayExam">
                <mat-option *ngFor="let exam of filteredExam | async" [value]="exam">
                    {{ exam.name }}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="checkError('examControl', 'required')">Exam is required</mat-error>
        </mat-form-field>
        <br>
        <mat-checkbox formControlName="isActive" style="margin-right: 10px;">Active</mat-checkbox>

    </form>
</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
    <button mat-button color="primary" [mat-dialog-close]="true" (click)="onSubmit()" [disabled]="!dataForm.valid">Add</button>
</mat-dialog-actions>


<!-- Copyright 2023 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->